/*
Karty produktów w sekcji vouchera. Twig renderuje je z linkiem i zdjęciem (zapas), a tu
dociągamy z /api/listing/products to, co się zmienia: bieżącą cenę (promocje zmieniają
się co kilka dni) i kanoniczny adres. Cena "z voucherem" = bieżąca cena minus voucher,
ale tylko od progu z regulaminu (voucher_min_basket) - taniej voucher nie działa,
więc karta pokazuje samą cenę.

Produkt, którego API nie zwróci (wyłączony w sklepie), chowamy. Gdy samo API nie
odpowie, karty zostają bez ceny - z działającym linkiem z Twiga.
*/

import formatPrice from '@js/utilities/formatPrice';
import { fillText } from './utils';

export async function initOffer(config) {
    const cards = [...document.querySelectorAll('[data-rpm-product]')];

    if (!cards.length || !config.listing_url) {
        return;
    }

    const query = cards
        .map((card) => `product_ids[]=${encodeURIComponent(card.dataset.rpmProduct)}`)
        .join('&');

    let products;

    try {
        const response = await fetch(`${config.listing_url}?${query}`, {
            headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
            return;
        }

        products = await response.json();
    } catch (e) {
        return;
    }

    cards.forEach((card) => {
        const product = products?.[card.dataset.rpmProduct];
        const price = Number(product?.price);

        if (!product || !price) {
            card.hidden = true;

            return;
        }

        if (product.url) {
            card.querySelectorAll('a').forEach((link) => {
                link.href = `/${product.url}`;
            });
        }

        const priceEl = card.querySelector('.rpm-prod__price');
        const oldPriceEl = priceEl.querySelector('s');
        const currentPriceEl = priceEl.querySelector('span');
        const voucherApplies = price >= Number(config.voucher_min_basket || 0);

        if (voucherApplies) {
            const withVoucher = Math.max(0, price - Number(config.voucher_value || 0));

            oldPriceEl.textContent = formatPrice(price);
            currentPriceEl.textContent = fillText(config.texts.offer_price_with_voucher, {
                price: formatPrice(withVoucher),
            });
        } else {
            currentPriceEl.textContent = formatPrice(price);
        }

        oldPriceEl.hidden = !voucherApplies;
        priceEl.hidden = false;
    });
}
